import { useI18n } from 'builder/hooks/useI18n'
import { ButtonTheme } from 'builder/components/Button'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { BtnTryAgain } from '../BtnTryAgain/BtnTryAgain'
import IconSrc from './icon.png'
import { Container, Img, ImgTextContainer, WrapperButton } from './styles'
interface Props {
  interviewId?: number
}

export const ShortOrOffTrackSection = ({ interviewId }: Props) => {
  const { i18n } = useI18n()
  const { isPhone } = useMediaQueries()

  return (
    <Container>
      <ImgTextContainer>
        <Img src={IconSrc} />

        <span>
          {i18n.t(`builder.interview_prep_view.feedbackV2.short_off_track_text1`)}
          <br />
          {i18n.t(`builder.interview_prep_view.feedbackV2.short_off_track_text2`)}
        </span>
      </ImgTextContainer>
      <WrapperButton>
        {interviewId && (
          <BtnTryAgain
            interviewId={interviewId}
            theme={isPhone ? ButtonTheme.ghost : ButtonTheme.default}
            withIcon={isPhone}
          />
        )}
      </WrapperButton>
    </Container>
  )
}
